import React, { useState, useEffect } from 'react';

import { Tabs, notification } from 'antd';
import ImportPreloading from '@src/components/logistics/import/preloading/import-preloading';
import LoadingPlans from '@src/components/logistics/import/preloading/loading-plans';

import { exception } from '@extensions/notification';
import { userLoaded } from '@store/actions';
import { useAppDispatch } from '@store/hooks';

import { serverFetch } from '@src/server';
import { ICountry } from '@entities/country';
import { ICity } from '@entities/city';

const Preloading = () => {
    const d = useAppDispatch();

    const [api, contextHolder] = notification.useNotification();

    const [countries, setCountries] = useState<Array<ICountry>>([]);
    const [cities, setCities] = useState<Array<ICity>>([]);

    useEffect(() => {
        let cleanup = false;

        const fetchData = async () => {
            const promises = [
                await serverFetch(`countries`, { method: 'GET' })
                    .then((data: any) => {
                        return data;
                    })
                    .catch((ex: any) => {
                        exception(api, 'Ошибка получения стран', ex, () => d(userLoaded(undefined)));
                    }),

                await serverFetch(`cities`, { method: 'GET' })
                    .then((data: any) => {
                        return data;
                    })
                    .catch((ex: any) => {
                        exception(api, 'Ошибка получения городов', ex, () => d(userLoaded(undefined)));
                    }),
            ];

            Promise.all([promises]).then((result) => {
                if (cleanup) return;

                setCountries(result[0][0].filter((c: ICountry) => c.generateTariff));
                setCities(result[0][1]);
            });
        };

        fetchData();
        return () => {
            cleanup = true;
        };
    }, []);

    const tabItems = [
        {
            label: `Импорт`,
            key: 'import',
            children: (
                <ImportPreloading cities={cities} countries={countries.filter((c) => c.code != 'NL')} api={api} serverFetch={serverFetch} />
            ),
        },
        {
            label: `План погрузок`,
            key: 'loadingPlans',
            children: <LoadingPlans countries={countries} api={api} serverFetch={serverFetch} />,
        },
    ];

    return (
        <>
            <Tabs size='small' items={tabItems}></Tabs>
            {contextHolder}
        </>
    );
};

export default Preloading;
